import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { deleteIdData } from "../../../lib/studentlessons";
import { getStudentIdData } from "../../../lib/studentlessonsview";

export default function GlobalStudentLessonforGrade({ slug, isStudent = true }) {
  const [lessons, setLessons] = useState([]);
  //const [classforLesson, setClassForLesson] = useState(9);

  const handleDelete = async (id) => {
    const choice = window.confirm("Are You Sure?");
    if (choice) {
      await deleteIdData(id);
      console.log("Delete", id);
    }
  };

  async function getData() {
    const lesson = await getStudentIdData(slug);
    setLessons(lesson);
    //console.log("lesson",lesson);
  }

  useEffect(() => {
    getData();
  }, []);

    const essentialheader = (
      name,
      studentbuttonname,
      studentbuttonlink,
      instructorbuttonname,
      instructorbuttonlink
    ) => {
      return (
        <div className="d-flex p-1 justify-content-between align-items-center">
          <div>
            <h3>{name}</h3>
            <p></p>
          </div>
          <div className="d-flex">
            <div className="ticket-btn-grp">
              {isStudent ? (
                <Link to={studentbuttonlink}>{studentbuttonname}</Link>
              ) : (
                <Link to={instructorbuttonlink}>{instructorbuttonname}</Link>
              )}
            </div>
          </div>
        </div>
      );
    };

  return (
    <div className="col-12">
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-2">
          {/* <div className="profile-heading">
            <h3>Lessons</h3>
            <div className="new-address">
              <div className="row">
                <div className="col"></div>
                <div className="col"> </div>
                <div className="col">
                  {isStudent ? (
                    <Link
                      to="/student911/student-lessons-edit/Add"
                      className="btn btn-dark btn-dark-1"
                    >
                      Add New Course
                    </Link>
                  ) : (
                    <Link
                      to={`/instructor/instructor-studentlessonedit/${slug}/Add`}
                      className="btn btn-dark btn-dark-1"
                    >
                      Add New Course
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div> */}
          {essentialheader(
            "Lessons",
            "Add New Course", 
            "/student911/student-lessonsforgrade-edit/Add",
            "Add New Course",
            `/instructor/instructor-studentlessoneditforgrade/${slug}/Add`,
            )}
          <div className="comman-space pb-0">
            <div className="settings-invoice-blk table-responsive">
              {/* Invoice info */}
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Department</th>
                    <th>Course</th>
                    <th>Status</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {lessons.map(function (data) {
                    return (
                      <tr key={data.id}>
                        <td>
                          <Link to="#" className="invoice-no">
                            {data.id}
                          </Link>
                        </td>
                        <td>{data.pname}</td>
                        <td>{data.lessonName}</td>
                        <td>
                          {data.isActive ? (
                            <span className="badge info-low">True</span>
                          ) : (
                            <span className="badge info-high">False</span>
                          )}
                        </td>
                        <td>
                          <div className="profile-share d-flex align-items-center justify-content-end">
                            {isStudent ? (
                              <Link
                                to={`/student911/student-lessonsforgrade-edit/${data.id}`}
                                className="btn btn-success btn-sm"
                              >
                                Update
                              </Link>
                            ) : (
                              <Link
                                to={`/instructor/instructor-studentlessoneditforgrade/${slug}/${data.id}`}
                                className="btn btn-success btn-sm"
                              >
                                Update
                              </Link>
                            )}
                            {/*}
                                    <button className="btn btn-danger btn-sm" onClick={() => handleDelete(data.id)}>
                                      Delete
                                    </button>
                            */}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {/* Invoice info */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
